module.exports = __webpack_public_path__ + "img/ai-sample-overview-2.9d896066.webp";